
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/live-webstream",
      function () {
        return require("private-next-pages/mahashivratri/live-webstream/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/live-webstream"])
      });
    }
  